import {Pipe, PipeTransform} from '@angular/core';
import {DeliveryNoteScanItemDto} from '../../../Models/Documents-review/delivery-note-review.interface';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Pipe({
  name: 'scanItems',
  standalone: false,
})
export class ScanItemsPipe implements PipeTransform {

  transform(items: DeliveryNoteScanItemDto[], deliveryNoteLines: LinesDto[], currentLine: LinesDto): DeliveryNoteScanItemDto[] {

    if (!items?.length) {
      return [];
    }

    const pairedItemIds = new Set(
      deliveryNoteLines
        .filter((line) => line.id !== currentLine.id)
        .map((line) => line.paired_scan_item?.id)
        .filter((id): id is number => id !== undefined)
    );

    return items.filter((item) => !pairedItemIds.has(item.id));

  }

}
